import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../../settings/index';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import Api from '../../../../../helpers/api';
import { t } from '../../../../../i18n';

const api = new Api('workers/:id/referrals');

function* loadData(data) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = data.payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter }, id },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { referrals, referrer, totalCount, filteredCount, sortable_columns } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: {
            referrals,
            referrer: referrer && Object.prototype.hasOwnProperty.call(referrer, 'name') ? referrer : null,
          },
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData(data) {
  try {
    const { id } = data.payload;

    const result = yield call(sendRequest, api.loadFormData, { id }, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      yield put(actions.loadFormDataSuccess({ data: result.data.success.data.referrals }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* addReferral(data) {
  try {
    const { id, referralId } = data.payload;
    const result = yield call(
      sendRequest,
      api.createItem,
      { data: { referral_id: referralId }, id },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.loadData({ id }));
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.added_successfully', {
            item: t('dash.talent.referrals_header'),
          }),
        }),
      );
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.talent.add_referral_error'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadData),
    takeEvery(actions.ADD_NEW_REFERRAL, addReferral),
    takeEvery(actions.LOAD_FORM_DATA, loadFormData),
  ]);
}
